module.exports = __webpack_public_path__ + "static/media/rule2.196b616b.png";